import api from '../../plugins/api';

const deleteAccount = () => {
    return api.post("/api/delete", {})
}

export default deleteAccount;